import CollapseIcon from '@icons/collapse.svg?react';
import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  MouseEvent,
  ReactNode
} from 'react';
import Styled from './NavItem.styled';

export interface NavItemProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement> &
      AnchorHTMLAttributes<HTMLAnchorElement>,
    'children' | 'onClick'
  > {
  icon?: ReactNode;
  label: string;
  selected?: boolean;
  showLabel?: boolean;
  linkHref?: string;
  expandable?: boolean;
  isExpanded?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
}

function NavItem({
  className,
  disabled = false,
  icon,
  label,
  linkHref,
  expandable = false,
  isExpanded = false,
  onClick,
  selected = false,
  showLabel = true,
  type = 'button',
  ...rest
}: NavItemProps) {
  const isLink = Boolean(linkHref);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    isLink && event.preventDefault();
    onClick?.(event);
  };

  return (
    <Styled.Root
      as={isLink ? 'a' : 'button'}
      href={linkHref}
      type={isLink ? undefined : type}
      className={className}
      disabled={disabled}
      $selected={selected}
      $showLabel={showLabel}
      $expandable={expandable}
      onClick={handleClick}
      {...rest}>
      {icon ? <Styled.LeadingIcon>{icon}</Styled.LeadingIcon> : null}
      {showLabel ? <Styled.Label>{label}</Styled.Label> : null}
      {expandable && showLabel ? (
        <Styled.TrailingIcon $isExpanded={isExpanded}>
          <CollapseIcon />
        </Styled.TrailingIcon>
      ) : null}
    </Styled.Root>
  );
}

export default NavItem;
